
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flights/premium-economy-class",
      function () {
        return require("private-next-pages/flights/premium-economy-class.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flights/premium-economy-class"])
      });
    }
  